<template>
	<div>
        <div class="theme-loader">
            <div class="ball-scale">
                <div class='contain'>
                    <img src="../assets/loader.gif">
                </div>
            </div>
        </div>
        <div id="pcoded" class="pcoded">
            <div class="pcoded-container">
                <!-- Menu header start -->
                <Navbar1 />
                <!-- Menu header end -->
                <div class="pcoded-main-container">

                    <Menu />
                    <!-- Sidebar inner chat end-->
                    <div class="pcoded-wrapper">
                        <div class="pcoded-content">
                            <div class="pcoded-inner-content">

                                <!-- Main-body start -->
                                <div class="main-body">
                                    <div class="page-wrapper">
                                        <!-- Page-header start -->
                                        <div class="page-header card m-t-40">
                                            <div class="row align-items-end">
                                                <div class="col-lg-8">
                                                    <div class="page-header-title">
                                                        <i class="icofont icofont-restaurant-menu bg-c-pink "></i>
                                                        <div class="d-inline">
                                                            <h4>Stage 2</h4>
                                                            <span>{{user_data.stages.process_details[0].process_name}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Page-header end -->
                                        <!-- Page body start -->
                                        <div class="page-body">
                                            <div class="row">
                                                <div class="col-lg-12">
                                                    <div class="card">
                                                        <div class="card-header">
                                                            <h5>{{user_data.stages.process_details[0].process_name}}</h5>
                                                            <br><br>
                                                            <div class="card-header-left">{{user_data.stages.process_details[0].description}}</div>
                                                        </div>
                                                        <div class="card-block">
                                                            <div v-if="processes.includes('CBT')">
                                                                <CBT />
                                                            </div>
                                                            <div v-else-if="user_data.stages.process_details[0].process_name == 'Video Upload'">
                                                                <VideoUpload />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- Default card end -->
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Page body end -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Navbar1 from '../components/Navbar1.vue'
import Menu from '../components/Menu.vue'
import CBT from '../components/CBT.vue'
import VideoUpload from '../components/VideoUpload.vue'

export default {
    name: 'Stage2',
    data(){
        return{
            user_data: {
                stages:{
                    process_details:[
                        {
                            process_name: ''
                        }
                    ]
                },
                stages_flow:[
                    {
                        process_details: ""
                    }
                ]
            }
        }
    },
    mounted(){
        var user_data = this.$store.getters.user_data.data
        this.user_data = user_data
    },
    components:{
        Navbar1,
        Menu,
        CBT,
        VideoUpload
    },

    computed :{
        processes () {
            return this.user_data.stages.process_details.reduce((acc, curr) => {
                                                                acc.push(curr.process_name)
                                                                return acc
                                                            }, [] )
        }
    }
}
</script>
